<template>
  <div-box :src="require('../../assets/img/zichan_bg@2x.png')">
    <nav-bar left-arrow :title="$t('闪兑')" bgColor="#000000" />
    <div-padding padding="4vw">
      <div-padding padding="4vw 0">
        <div-flex left>
          <div-img width='4vw' height='4vw'>
            <img src="../../assets/img/zujian@2x.png" alt="">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('闪兑') }}</div-text>
        </div-flex>
      </div-padding>
      <!-- 输入框开始 -->
      <div-card bg="#242424" padding='3vw' radius='2vw'>
        <div-flex left>
          <div-width width='24vw'>
            <div-text size='4vw' color='#FFFFFF'>{{ $t('闪兑币种') }}</div-text>
          </div-width>

          <div-card v-if="info.act == 1" @click="active = 0; get_num()" :bg='active == 0 ? "#CEB082" : "#242424"'
            width="17vw" border="1px solid #CEB082" padding='0.5vw 0vw'>
            <div-text :color='active == 0 ? "#242424" : "#CEB082"' align="center" size='4vw'>USDT</div-text>
          </div-card>

          <div-width width='3vw' v-if="info.act == 1" />
          <div-card v-if="info.card == 1" @click="active = 1; get_num()" :bg='active == 1 ? "#CEB082" : "#242424"'
            width="17vw" border="1px solid #CEB082" padding='0.5vw 0vw'>
            <div-text :color='active == 1 ? "#242424" : "#CEB082"' align="center" size='4vw'>{{ $t('卡牌') }}</div-text>
          </div-card>

          <div-width width='3vw' v-if="info.card == 1" />
          <div-card v-if="info.usdt == 1" @click="active = 2; get_num()" :bg='active == 2 ? "#CEB082" : "#242424"'
            width="17vw" border="1px solid #CEB082" padding='0.5vw 0vw'>
            <div-text :color='active == 2 ? "#242424" : "#CEB082"' align="center" size='4vw'>ACT</div-text>
          </div-card>

          <div-width width='3vw' v-if="info.acts == 1" />
          <div-card v-if="info.acts == 1" @click="active = 3; get_num()" :bg='active == 3 ? "#CEB082" : "#242424"'
            width="17vw" border="1px solid #CEB082" padding='0.5vw 0vw'>
            <div-text :color='active == 3 ? "#242424" : "#CEB082"' align="center" size='4vw'>ACTs</div-text>
          </div-card>

        </div-flex>
      </div-card>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field class="num" :border='false' @input="get_num()" clearable type="number" :formatter="formatter"
            v-model='num'
            :placeholder='$t("请输入闪兑数量") + `(${[info.act_min, info.card_min, info.usdt_min, info.acts_min][active]}-${[info.act_max, info.card_max, info.usdt_max, info.acts_max][active]})`'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('闪兑数量') }}</div-text>
              </div-width>
            </template>
            <template #button>
              <div-text size='4vw' color='#CEB082'>{{ ["USDT", $t("卡牌"), "ACT", "ACTs"][active] }}</div-text>
            </template>
          </van-field>
        </div-card>
      </div-input>

      <div-padding padding="3vw">
        <div-text color='#CEB082' size='4vw' v-if="active == 0">{{ $t('可用') }}：{{ usdt }}USDT</div-text>
        <div-text color='#CEB082' size='4vw' v-if="active == 2">{{ $t('可用') }}：{{ act }}ACT</div-text>
        <div-text color='#CEB082' size='4vw' v-if="active == 1">{{ $t('可用') }}：{{ card }}{{ $t('卡牌') }}</div-text>
        <div-text color='#CEB082' size='4vw' v-if="active == 3">{{ $t('可用') }}：{{ acts }}ACTs</div-text>
      </div-padding>
      <div-height height='4vw' />
      <div-flex center>
        <div-img width='5vw' height='8vw'>
          <img src='../../assets/img/zhaunhuan.png' />
        </div-img>
      </div-flex>
      <div-height height='2vw' />
      <div-padding padding="4vw 0">
        <div-flex>
          <div-flex left>
            <div-img width='4vw' height='4vw'>
              <img src="../../assets/img/zujian@2x.png" alt="">
            </div-img>
            <div-width width='1vw' />
            <div-text color='#fff' size='4vw'>{{ $t('支付') }}</div-text>
          </div-flex>
          <!-- <div-text color='#CEB082' size='4vw' v-if="active==0">{{$t('可用')}}：{{usdt}}USDT</div-text>
          <div-text color='#CEB082' size='4vw' v-if="active==2">{{$t('可用')}}：{{act}}ACT</div-text>
          <div-text color='#CEB082' size='4vw' v-if="active==1">{{$t('可用')}}：{{card}}{{$t('卡牌')}}</div-text> -->
        </div-flex>
      </div-padding>
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable readonly :value='["ACT", "ACT", "USDT", "USDT"][active]'
            :placeholder='$t("自动计算")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('支付币种') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>
      <div-height height='3vw' />
      <div-card bg="#242424" padding='3vw' radius='2vw'>
        <div-flex left>
          <div-width width='24vw'>
            <div-text size='4vw' color='#FFFFFF'>{{ $t('手续费') }}{{ [info.act_fee, info.card_fee, info.usdt_fee,
            info.acts_fee][active]
            }}%</div-text>
          </div-width>
          <div-text size='4vw' color='#CEB082'>{{ new_info.fee_amount || 0 }}</div-text>
        </div-flex>
      </div-card>
      <div-height height='3vw' />
      <div-input>
        <div-card bg="#242424" padding='3vw' radius='2vw'>
          <van-field :border='false' clearable readonly
            :value="new_info.actual_amount ? (new_info.actual_amount * 1 + new_info.fee_amount * 1).toFixed(4) : ''"
            :placeholder='$t("自动计算")'>
            <template #label>
              <div-width width='20vw'>
                <div-text size='4vw' color='#FFFFFF'>{{ $t('支付数量') }}</div-text>
              </div-width>
            </template>
          </van-field>
        </div-card>
      </div-input>

      <div-height height='3vw' />
      <div-text color='#CEB082' size='4vw' v-if="active == 2 || active == 3">{{ $t('可用') }}：{{ usdt }}USDT</div-text>
      <div-text color='#CEB082' size='4vw' v-if="active == 0 || active == 1">{{ $t('可用') }}：{{ act }}ACT</div-text>
      <div-height height='5vw' />
      <div-btn @click.native="one()" radius="3vw" bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
        <div-text color='#242424' blod size='4vw'>{{ $t('确定') }}</div-text>
      </div-btn>
      <div-height height='8vw' />
      <div-padding padding="4vw 0">
        <div-flex left>
          <div-img width='4vw' height='4vw'>
            <img src="../../assets/img/zujian@2x.png" alt="">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('闪兑说明') }}</div-text>
        </div-flex>
      </div-padding>
      <div-text color='#999' size='4vw'>{{ info.exchange_rule }}</div-text>
    </div-padding>

    <van-popup class="popupcode" v-model="show_code" style="width: 76%;top:40%;" closeable>
      <div class="content">
        <p>{{ $t('交易密码') }}</p>
        <van-field v-model="password" type="password" maxlength="6" :placeholder="$t('请输入交易密码')" clearable
          :border="false" />
        <van-button block color="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)" :loading="loading" @click="pay">{{
          $t('确定') }}</van-button>
      </div>
    </van-popup>
  </div-box>
</template>

<script>
import debounce from 'lodash/debounce';
export default {
  data() {
    return {
      active: 0,
      num: "",
      info: {},
      act: 0,
      usdt: 0,
      card: 0,
      show_code: false,
      loading: false,
      password: "",
      new_info: {},
    }
  },
  created() {
    this.get_info()
  },
  methods: {
    one() {
      if (!this.num) return this.$toast(this.$t("请输入闪兑数量"))
      this.show_code = true
    },
    get_num: debounce(function () {
      this.$get({
        url: "/api/v1/user/exchange/amount",
        data: {
          amount: this.num || 0,
          type: [2, 3, 1, 4][this.active],
        },
        success: (res) => {
          this.new_info = res.data
        },
        tip: () => { },
      })
    }, 800),
    pay() {
      if (!this.password) return this.$toast(this.$t("请输入交易密码"))
      if (this.loading == true) {
        return this.$toast(this.$t("请勿重复提交"))
      }
      this.loading = true
      this.$post({
        url: "/api/v1/user/exchange",
        data: {
          amount: this.num,
          type: [2, 3, 1, 4][this.active],
          trade_password: this.password,
        },
        success: (res) => {
          this.password = ""
          this.num = ""
          this.show_code = false
          this.$toast(this.$t("操作成功"))
          this.get_info()
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
        tip: () => {
          this.password = ""
          this.num = ""
          this.show_code = false
          this.get_info()
          setTimeout(() => {
            this.loading = false
          }, 2000)
        },
      })
    },
    formatter(value) {
      // Remove any non-numeric characters
      value = value.replace(/[^0-9.]/g, "")

      // Limit to two decimal places
      const decimalIndex = value.indexOf(".")
      if (decimalIndex !== -1) {
        value = value.slice(0, decimalIndex + 5)
      }

      return value
    },
    get_info() {
      this.$get({
        url: "/api/v1/user/info",
        success: (res) => {
          this.act = res.data.act
          this.usdt = res.data.usdt
          this.card = res.data.card
          this.acts = res.data.acts
        },
        tip: () => { },
      })
      this.$get({
        url: "/api/v1/financial",
        success: (res) => {
          this.info = res.data
        },
        tip: () => { },
      })
    },
  },
}
</script>
<style lang='less' scoped>
/deep/.van-field__control {
  color: #fff !important;
  font-size: 4vw !important;
}

.num {
  /deep/.van-field__control::placeholder {
    color: rgba(150, 150, 150, 1) !important;
  }
}
</style>